import { Exception } from "./Exception";

export class MinMaxException extends Exception {

    constructor() {
        super('max_min_error', `Min > Max`);
    }
}